import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalendar2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"calendar-2, date"} maskId="square-filled-radius-0-stroke-1-IconCalendar2"><path fillRule="evenodd" clipRule="evenodd" d="M3 4H7V2H8V4H16V2H17V4H21V21H3V4ZM20 10H4V20H20V10Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCalendar2;
